(ns manage.ad-variant-preview.meta
  (:require ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Typography$default" :as Typography]
            ["react-use/lib/useEvent$default" :as useEvent]
            ["src/svg/arrows/arrow-turn-up-right.svg$default" :as ArrowTurnUpRight]
            ["src/svg/chevron/chevron-left.svg$default" :as ChevronLeft]
            ["src/svg/chevron/chevron-right.svg$default" :as ChevronRight]
            ["src/svg/controls/ellipsis-vertical.svg$default" :as EllipsisVertical]
            ["src/svg/editor/emoji/thumbs-up.svg$default" :as ThumbsUp]
            ["src/svg/inform/bubble-left.svg$default" :as BubbleLeft]
            ["src/svg/inform/cross.svg$default" :as Cross]
            ["src/svg/location/globe-europe-africa.svg$default" :as GlobeEuropeAfrica]
            ["src/svg/shapes/circle/circle-small-fill.svg$default" :as CircleSmallFill]
            [lemonpi.ads-schema.interface :as ads-schema]
            [manage.ad-variant-preview.data :as data]
            [manage.ad-variant-preview.viewport :as viewport]
            [uix.core :as uix :refer [$ defui]]))

(defn get-value [components k]
  (let [{:keys [error value]} (or (get components k)
                                  {:error {:message [(str "Missing " (name k))]}})]
    (if error
      ($ Typography
         {:component "span"
          :sx #js {:color "red"}}
         (first (:message error)))
      value)))

(def ^:private meta-action-button-sx
  #js {:flex 1
       :color "#616770"
       :fontSize "12px"
       :fontWeight 500
       :cursor "default"
       "&:hover" #js {:backgroundColor "initial"}})

(defui meta-ad-footer [{:keys [headline description cta show-website?]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :sx #js {:backgroundColor "#F7F8FA"
               :borderBottom "1px solid #ccc"
               :p "12px"
               :overflow "hidden"}}
     ($ Stack
        {:direction "column"
         :flex 1
         :sx #js {:overflow "hidden"}}
        (when show-website?
          ($ Typography
             {:fontSize "13px"
              :sx #js {:color "#5E6066"}}
             ;; FIXME: From adset config?
             "mywebsite.com"))
        ($ Typography
           {:fontWeight 700
            :fontSize "15px"
            :noWrap true
            :sx #js {:color "#1C2028"}}
           headline)
        (when description
          ($ Typography
             {:fontSize "15px"
              :noWrap true
              :sx #js {:color "#5E6066"}}
             description)))
     (when cta
       ($ Button
          {:variant "contained"
           :sx #js {:backgroundColor "#E4E6EB"
                    :color "#050505"
                    :boxShadow "none"
                    :fontSize "15px"
                    :ml "6px"
                    "&:hover" #js {:backgroundColor "#E0E2E9"
                                   :boxShadow "none"}}}
          cta))))

(defui meta-wrapper [{:keys [width components children carousel?]}]
  ;; These elements are using px on purpose so they aren't dependent on our MUI theme
  ;; selection.
  ;; Same with fonts override. Roboto font is loaded in the `content` component
  ;; if the adset contains meta variants.
  ($ Stack
     {:sx #js {:width width
               :backgroundColor "#fff"
               "*" #js {:fontFamily "Roboto, Arial, sans-serif"}}}
     ($ Stack
        {:direction "row"
         :spacing "12px"
         :px "12px"
         :pt "12px"
         :alignItems "center"
         :mb "12px"}
        ($ Avatar
           {:sx #js {:backgroundColor "#828487"
                     :color "#353E4E"
                     :width 40
                     :height 40
                     :fontSize "22px"
                     :fontWeight 700}}
           "M")
        ($ Stack
           {:direction "column"
            :flex 1}
           ($ Typography
              {:fontSize "14px"
               :fontWeight 700}
              ;; FIXME: From adset config?
              "My page")
           ($ Stack
              {:direction "row"
               :alignItems "center"}
              ($ Typography
                 {:fontSize "12px"
                  :sx #js {:color "#9FA3AA"}}
                 "Sponsored")
              ($ SvgIcon
                 {:component CircleSmallFill
                  :sx #js {:mx "2px"
                           :color "#9FA3AA"
                           :width 6
                           :height 6}})
              ($ SvgIcon
                 {:component GlobeEuropeAfrica
                  :sx #js {:color "#9FA3AA"
                           :width 12
                           :height 12}})))
        ($ Cross
           {:width 30
            :height 30})
        ($ EllipsisVertical
           {:width 38
            :height 38}))
     ($ Stack
        {:direction "row"
         :mb 1}
        ($ Typography
           {:sx #js {:px "12px"
                     :textOverflow "ellipsis"
                     :overflow "hidden"
                     :display "-webkit-box"
                     :WebkitLineClamp 2
                     :WebkitBoxOrient "vertical"}
            :fontSize "15px"}
           (get-value components :urn:meta:primary-text)))
     children
     (when-not carousel?
       ($ meta-ad-footer
          {:headline (get-value components :urn:meta:headline)
           :description (get-value components :urn:meta:description)
           :cta (get-value components :urn:meta:cta)
           :show-website? true}))
     ($ Stack
        {:direction "row"
         :sx #js {:px "12px"
                  :pt "17px"}}
        ($ Stack
           {:direction "row"
            :flex 1
            :spacing "3px"
            :sx #js {:borderTop "1px solid #ccc"
                     :py "3px"}}
           ($ Button {:sx meta-action-button-sx :startIcon ($ ThumbsUp)} "Like")
           ($ Button {:sx meta-action-button-sx :startIcon ($ BubbleLeft)} "Comment")
           ($ Button {:sx meta-action-button-sx :startIcon ($ ArrowTurnUpRight)} "Share")))))

(defui media-unavailable
  "Shown instead of a carousel card's media when the card is customized per placement
   (several media) but none of them is within tolerance of the previewed aspect ratio."
  [{:keys [width height]}]
  ($ Box {:sx #js {:position "relative" :width width :height height :flexShrink 0}}
     ($ Skeleton {:variant "rectangular" :sx #js {:width "100%" :height "100%"}})
     ($ Stack
        {:justifyContent "center"
         :alignItems "center"
         :sx #js {:position "absolute"
                  :inset 0
                  :px "16px"
                  :textAlign "center"}}
        ($ Typography {:fontSize "13px" :sx #js {:color "#5E6066"}}
           "No asset available for this dimension"))))

(defui carousel-card [{:keys [card card-width is-current set-video-status video-controls target-ratio]}]
  (let [{:keys [headline description cta]} card
        media (data/closest-media-for-ratio (ads-schema/carousel-card-media-list card) target-ratio)
        video? (= "video" (:kind media))
        media-url (:url media)
        thumbnail-url (-> media :thumbnail :url)
        card-height (data/carousel-card-height card-width media)
        {:keys [event-target]} (viewport/use-context)
        {:keys [start end]} video-controls
        video-ref (uix/use-ref nil)
        temp-pause (uix/use-ref false)]

    (uix/use-effect (fn []
                      (when (and video? is-current)
                        (let [el @video-ref]
                          (set-video-status assoc :el el)
                          (when (and el (not (js/isNaN (.-duration el))))
                            (set-video-status assoc :duration (.-duration el))))
                        (fn []
                          (set-video-status nil))))
                    ^:lint/disable
                    [video? is-current])

    (uix/use-effect (fn []
                      (when (and video? (not is-current))
                        (when-let [el @video-ref]
                          (.pause el))))
                    ^:lint/disable
                    [video? is-current])

    (useEvent "play"
              (fn [e]
                (when (and video? is-current)
                  (when-let [el @video-ref]
                    (let [{:keys [all-end]} (.-data e)
                          t (.-currentTime el)]
                      (when (or (and start (<= t start))
                                (and end (>= t end)))
                        (set! (.-currentTime el) (or start 0)))
                      (when (or all-end
                                (and end (< t end))
                                (not (.-ended el)))
                        (.play el))))))
              event-target)

    (useEvent "pause"
              (fn [_e]
                (when (and video? is-current)
                  (when-let [el @video-ref]
                    (.pause el))))
              event-target)

    (useEvent "seek"
              (fn [e]
                (when (and video? is-current)
                  (when-let [el @video-ref]
                    (let [{:keys [target save-position restore-position]} (.-data e)]
                      (when (and save-position (not (.-paused el)))
                        (reset! temp-pause true)
                        (.pause el))
                      (when target
                        (set! (.-currentTime el) target))
                      (when (and restore-position @temp-pause)
                        (reset! temp-pause false)
                        (.play el))))))
              event-target)

    (useEvent "toggleMute"
              (fn [_e]
                (when (and video? is-current)
                  (when-let [el @video-ref]
                    (set! (.-muted el) (not (.-muted el))))))
              event-target)

    ($ Stack
       {:sx #js {:minWidth card-width
                 :maxWidth card-width
                 :flexShrink 0}}
       (cond
         (nil? media)
         ($ media-unavailable {:width card-width :height card-height})

         video?
         ($ :video
            {:ref video-ref
             :src media-url
             :poster thumbnail-url
             :autoPlay false
             :muted true
             :controls false
             :playsInline true
             :width card-width
             :height card-height
             :style {:pointer-events "none"
                     :object-fit "cover"
                     :display "block"}
             :type "video/mp4"

             :onPlaying
             (fn [_e]
               (when is-current
                 (set-video-status assoc :status "playing")))

             :onPause
             (fn [e]
               (when is-current
                 (set-video-status assoc :status (if (and end (>= (.-currentTime (.-target e)) end))
                                                   "end"
                                                   "paused"))))

             :onLoadedMetadata
             (fn [e]
               (when is-current
                 (set-video-status assoc :duration (.. e -target -duration))))

             :onTimeUpdate
             (fn [e]
               (when (and is-current end (>= (.-currentTime (.-target e)) end))
                 (.pause (.-target e))
                 (set-video-status assoc :status "end")))

             :onEnded
             (fn [_e]
               (when is-current
                 (set-video-status assoc :status "end")))})

         :else
         ($ Box
            {:component "img"
             :src media-url
             :sx #js {:width card-width
                      :height card-height
                      :objectFit "cover"
                      :display "block"}}))
       ($ meta-ad-footer
          {:headline (or headline "")
           :description description
           :cta cta
           :show-website? false}))))

(defui carousel-nav-button [{:keys [dir on-click]}]
  (let [prev? (= dir :prev)]
    ($ Box (js/Object.assign #js {:position "absolute"
                                  :top "40%"
                                  :zIndex 1
                                  :bgcolor "grey.80"
                                  :borderRadius 2}
                             (if prev? #js {:left 8} #js {:right 8}))
       ($ IconButton {:onPointerDown (fn [e] (.stopPropagation e))
                      :onClick on-click
                      :sx #js {:borderRadius 2}}
          ($ SvgIcon {:component (if prev? ChevronLeft ChevronRight)
                      :sx #js {:fontSize 32}})))))

(defui preview-format-selector
  "Which Meta placement aspect ratio a multi-placement carousel previews with. Every
   caller provides this same look, only the surrounding chrome (e.g. a bar with a
   bottom divider) differs by context. Formats in `disabled-formats` (e.g. not
   uploaded yet) are greyed out and can't be picked."
  [{:keys [format set-format disabled-formats]}]
  ($ Stack {:direction "row" :alignItems "center" :gap 2}
     ($ Typography {:fontSize "13px" :sx #js {:color "text.secondary"}} "Preview format")
     ($ ToggleButtonGroup
        {:value format
         :size "small"
         :exclusive true
         :onChange (fn [_e value] (when value (set-format value)))
         :sx #js {:gap "8px"
                  "& .MuiToggleButtonGroup-grouped" #js {:border "1px solid"
                                                         :borderColor "grey.60"
                                                         :borderRadius "8px !important"
                                                         :marginLeft "0 !important"
                                                         :px "12px"}}}
        (for [fmt data/preview-formats]
          ($ ToggleButton {:key fmt :value fmt :disabled (contains? disabled-formats fmt)} fmt)))))

(defui carousel
  [{:keys [component width set-video-status video-controls on-current-card-video-change]
    {:keys [card-index on-card-change]} :carousel-controls}]
  (let [cards (or (:value component) [])
        card-count (count cards)
        ;; The format selector now always lives outside the carousel, provided by every
        ;; page that can show one (the preview page, manual upload, ad-variant details),
        ;; shared through context so every carousel on screen previews the same format.
        {:keys [preview-format]} (viewport/use-context)
        target-ratio (get data/preview-format->ratio (or preview-format (first data/preview-formats)))
        peek 80
        gap 16
        card-width (- width (* 2 peek))
        [current-index set-current-index!] (uix/use-state 0)
        current-card-media (data/closest-media-for-ratio
                            (ads-schema/carousel-card-media-list (get cards current-index))
                            target-ratio)
        current-card-video? (= "video" (:kind current-card-media))
        can-prev? (pos? current-index)
        can-next? (< current-index (dec card-count))
        offset (cond
                 (zero? current-index) gap
                 (= current-index (dec card-count)) (- width card-width gap)
                 :else peek)
        navigate! (fn [idx]
                    (set-current-index! idx)
                    (when on-card-change (on-card-change idx)))]
    (uix/use-effect (fn []
                      (when on-current-card-video-change
                        (on-current-card-video-change current-card-video?)))
                    ^:lint/disable
                    [current-card-video?])
    (uix/use-effect (fn []
                      (when (some? card-index)
                        (set-current-index! card-index)))
                    [card-index])
    ($ Box {:sx #js {:position "relative"}}
       ($ Box {:sx #js {:overflow "hidden" :width width}}
          ($ Stack
             {:direction "row"
              :gap (str gap "px")
              :sx #js {:transform (str "translateX("
                                       (- offset (* current-index (+ card-width gap)))
                                       "px)")
                       :transition "transform 0.3s ease"}}
             (for [i (range card-count)]
               ($ carousel-card
                  {:key i
                   :card (nth cards i)
                   :card-width card-width
                   :is-current (= i current-index)
                   :set-video-status set-video-status
                   :video-controls video-controls
                   :target-ratio target-ratio}))))
       (when can-prev?
         ($ carousel-nav-button {:dir :prev :on-click #(navigate! (dec current-index))}))
       (when can-next?
         ($ carousel-nav-button {:dir :next :on-click #(navigate! (inc current-index))})))))
